import type { NavigateProps } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

export interface AppRedirectProps extends Omit<NavigateProps, 'replace'> {
  push?: boolean
  replace?: boolean
}

export function AppRedirect({ push, replace, ...props }: AppRedirectProps) {
  return <Navigate {...props} replace={replace ?? !push} />
}
